import utils from "../../../utils/utils";

export default {
    async fetchConnectedAccounts(context, payload) {
        const response = await utils.utility.fetch(`api/Setting/GetSocialMediaAccounts?source=${payload.source}&accountType=${payload.accountType}&pageNumber=${payload.pageNumber}&pageSize=${payload.pageSize}&sortColumn=${payload.sortColumn}&sortDirection=${payload.sortDirection}&searchText=${payload.searchText}`);                
        
        context.commit("setConnectedAccounts", response.data);
    },
    async deleteAccount(_,payload) {
        await utils.utility.fetch("api/Setting/DeleteSocialMediaAccount","PUT",null, payload);        
    },
    async fetchClientDetails(context, payload) {
        const companyId = payload.id
        const response = await utils.utility.fetch(`api/Setting/GetLinkedinDefinition?companyId=${companyId}`);
        
        context.commit("setClientDetails", response.data);
    }
}